<template>
  <div>
    <el-dialog
      :visible.sync="openEditEvent"
      :close-on-click-modal="false"
      @close="onClose"
      :modal="false"
      :title="dataInvoices.Title"
    >
      <el-form :model="dataInvoices" label-position="top">
        <el-row style="display: flex; gap: 5px">
          <el-col :span="13">
            <el-form-item label="Descripción" prop="title">
              <el-input v-model="dataInvoices.Title"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="13">
            <el-form-item label="Monto">
              <input
                type="number"
                v-model="dataInvoices.Amount"
                class="inputAmount"
                @input="dataInvoices.Amount = parseFloat(dataInvoices.Amount)"
                step="0.01"
              />
              =
              <input v-model="amountoFormat" disabled class="inputAmount" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Fecha de facturación">
          <el-col :span="11">
            <el-date-picker
              type="datetime"
              placeholder="Fecha"
              v-model="dataInvoices.BillingDate"
              style="width: 100%"
            ></el-date-picker>
          </el-col>
        </el-form-item>

        <el-col class="ml-15" :span="3">
          <el-form-item label="Estado">
            <el-switch
              v-model="dataInvoices.Paid"
              active-color="#368939"
              inactive-color="#ff352e"
            ></el-switch>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">Cancelar</el-button>
        <el-button type="primary" @click="submitEvent">Guardar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatMonto } from "@/utils";
import { getReportDataFacturasMes } from "@/components/activity_flow/DialogLocker/InvoicesOrPaymentsFunctions.js";

export default {
  name: "EditEventFinances",
  props: {
    openEditEvent: {
      type: Boolean,
      default: false
    },
    dataInvoices: {
      type: Object,
      default: () => {}
    },
    dialogTitleEvent: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      getReportDataFacturasMes,
      amountoFormat: formatMonto(this.dataInvoices.Amount)
    };
  },
  methods: {
    onClose() {
      this.$emit("onClose", this.openEditEvent);
    },
    submitEvent() {
      let data = {
        Amount: this.dataInvoices.Amount,
        StarDate: this.dataInvoices.BillingDate,
        Paid: this.dataInvoices.Paid,
        Title: this.dataInvoices.Title,
        Id: this.dataInvoices.Id,
        UpdatedByUser_Id: this.currentUser.UserID
      };
      this.$http
        .put("/api/CalendarFinances/editEventFinances", data)
        .then(() => {
          this.$message({
            message: "Evento Editado",
            type: "success"
          });
          //this.getReportDataFacturasMes(this);
          this.onClose();
        });
    }
  },
  watch: {
    dataInvoices: {
      handler: function () {
        //console.log("valor del type: ",f.type)
        this.amountoFormat = formatMonto(this.dataInvoices.Amount);
      },
      deep: true
    }
  }
};
</script>
<style scoped>
.inputAmount {
  border-radius: 5px solid #e4e7ed;
  height: 30px;
  border-color: 1px solid #e4e7ed;
}
</style>
